import {
  INICIALITZAR,
  INDIVIDU_INICIALITZAR,
  INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP,
  INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS,
  OBTENIR_DADES_INDIVIDU,
  ESBORRAR_INDIVIDU_SELECCIONAT
} from "../../../actions/actionTypes";

export const INDIVIDU_FORMULARI_DADES_EDITADES_ESTAT_INICIAL = {
  id: null,
  altitud: null,
  dataBaixa: null,
  descripcio: null,
  latitud: null,
  longitud: null,
  motiuBaixa: null,
  nomCientific: null,
  idIndividuVegetal: null,
  idIndret: null,
  nomIndret: null,
  idObservador: null,
  nomObservador: null,
  fenofases: null,
  idEspecie: null,
  nomEspecie: null,
  idSubespecie: null,
  nomSubespecie: null,
  idVarietat: null,
  nomVarietat: null,
  idGenere: null,
  nomGenere: null,
  idCollectiu: null,
  nomCollectiu: null,
  idClasse: null,
  nomClasse: null,
  idRegne: null,
  nomRegne: null,
  indretIndividuDataAlta: null,
  canvis: null,
  solana: null,
  plantada: null,
  fertilitzat: null,
  reg: null,
  genotip: null
};

const editades = (
  state = INDIVIDU_FORMULARI_DADES_EDITADES_ESTAT_INICIAL,
  action
) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR || INICIALITZAR:
    case INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS:
    case `${OBTENIR_DADES_INDIVIDU}_EN_CURS`:
    case `${OBTENIR_DADES_INDIVIDU}_ERROR`:
    case ESBORRAR_INDIVIDU_SELECCIONAT:
      return INDIVIDU_FORMULARI_DADES_EDITADES_ESTAT_INICIAL;

    case INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP: {
      const { idCamp, valor } = action;
      return { ...state, [idCamp]: valor };
    }

    case `${OBTENIR_DADES_INDIVIDU}_SUCCESS`: {
      return action.payload.individu;
    }

    default:
      return state;
  }
};

export default editades;
